"use strict";

module.exports = function (column, start, end) {
  var dateFormat = this.dateFormat(column);
  var el = typeof column === 'string' ? $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter") : column;
  el.text(start.format(dateFormat) + " - " + end.format(dateFormat));
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/set-datepicker-text.js
// module id = 1624
// module chunks = 64